<template>
  <div>

    <dl class="row text-nowrap">
      <dt class="col-sm-1">Name</dt>
      <dd class="col-sm-11">Copy {{copyId}}</dd>

      <template v-if="isDataLoaded">
        <dt class="col-sm-1">Time</dt>
        <dd class="col-sm-11">{{copy.ctime | getMomentStr}}</dd>
      </template>
    </dl>

    <loading-indicator
      v-if="isLoading"
    />

    <player-resource-log-items
      v-if="isDataLoaded"
      :items="copy.items"
    />

<!--
    <table v-if="isDataLoaded && copy.items.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Time</th>
          <th scope="col">Action</th>
          <th scope="col">Product</th>
          <th scope="col" class="text-right">Old amount</th>
          <th scope="col" class="text-right">Delta</th>
          <th scope="col" class="text-right">Result</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in copy.items">
        <tr :key="item.id">
          <td>{{item.ctime | getMomentStr}}</td>
          <td>{{item.action | getActionName}}</td>
          <td>{{item.proto_id | getProtoAlias}}</td>
          <td class="text-right">{{item.old_amount | getFormattedNumber}}</td>
          <td
            class="text-right"
            :class="getDeltaClass(item.new_amount - item.old_amount)"
          >
            {{item.new_amount - item.old_amount | getFormattedDifference}}
          </td>
          <td class="text-right">{{item.new_amount | getFormattedNumber}}</td>
        </tr>
        </template>
      </tbody>
    </table>
-->
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerResourceLogItems from './PlayerResourceLogItems.vue';
import { getProtoAlias } from '../util';

export default {
  name: 'PlayerResourceLogCopy',

  components: {
    LoadingIndicator,
    PlayerResourceLogItems,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    copyId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      copy: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.copy !== null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/resource_log_copy/${this.copyId}`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }
      this.copy = data;

      addAliases(this.copy.items);
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};

function addAliases(items) {
  for(let i = 0; i < items.length; i++) {
    const item = items[i];
    item.productAlias = getProtoAlias(item.proto_id);
  }
}
</script>
